var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var ViewAllLink = /** @class */ (function (_super) {
    __extends(ViewAllLink, _super);
    function ViewAllLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ViewAllLink.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-ev-list__view-all-link__wrap", "data-uat": "div-ev-list-view-all-link-wrap" },
            React.createElement("a", { className: "rj-ev-list__view-all-link", href: this.props.href, onClick: function (e) { return _this.props.handler(e, e.target); }, "data-uat": "a-ev-list-view-all-link" }, this.props.title)));
    };
    return ViewAllLink;
}(React.PureComponent));
export { ViewAllLink };
//# sourceMappingURL=ViewAllLink.js.map